/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'
import _ from 'lodash'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import AttributeReport from '../../../features/reports/attribute/AttributeReport'

export const types = {
  ADD_ATTRIBUTE_SESSION: 'rank-zone/ADD_ATTRIBUTE_SESSION',
  ADD_OVERLAP_CHART: 'attribute-report/ADD_OVERLAP_CHART',
  ADD_CUSTOM_DATA: 'attribute-report/ADD_CUSTOM_DATA',
  RESET_CUSTOM_DATA: 'attribute-report/RESET_CUSTOM_DATA',
  DELETE_CUSTOM_ITEM: 'attribute-report/DELETE_CUSTOM_ITEM',
  ADD_CUSTOM_REPORT: 'attribute-report/ADD_CUSTOM_REPORT',
  SET_NEW_CUSTOM_DATA: 'attribute-report/SET_NEW_CUSTOM_DATA'
}
const state = {
  attributes: [],
  all: {},
  custom: [],
  overlapChartData: null,
  overlapCustomReport: null
}

const mutations = {
  [types.ADD_ATTRIBUTE_SESSION]: function (state, { all, attributes }) {
    state.attributes = attributes || []
    state.all = all || {}
  },
  [types.ADD_OVERLAP_CHART]: function (state, data) {
    state.overlapChartData = data
  },
  [types.ADD_CUSTOM_DATA]: function (state, data) {
    data && state.custom.push(data)
  },
  [types.RESET_CUSTOM_DATA]: function (state) {
    state.custom = []
  },
  [types.DELETE_CUSTOM_ITEM]: function (state, item) {
    state.custom.splice(state.custom.indexOf(item), 1)
  },
  [types.ADD_CUSTOM_REPORT]: function (state, data) {
    state.overlapCustomReport = data
  },
  [types.SET_NEW_CUSTOM_DATA]: function (state, data) {
    state.custom = _.cloneDeep(data)
  }
}

async function fetchCustomReport ({ clientId, filters }) {
  const selectedIds = {}
  if (!_.isEmpty(filters.selectedIds.exclude)) {
    selectedIds['exclude'] = filters.selectedIds.exclude.join(',')
  }
  if (!_.isEmpty(filters.selectedIds.include)) {
    selectedIds['include'] = filters.selectedIds.include.join(',')
  }
  const msv = localStorage.getItem('msv') || 1
  const params = convertAdvancedOptionsToURLParams({ ...selectedIds, advancedFilters: filters.advancedFilters, msv })
  const response = await httpService.get(`/reports/attribute-report/custom/${clientId}`, { params })
  if (!response || !response.data) {
    return
  }
  const result = _.get(response, 'data.result', null)
  return { result, response }
}

const actions = {
  getAttributeData: async function ({ commit }, { clientId, filters }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    filters.msv = msv[clientId] || 1
    const params = convertAdvancedOptionsToURLParams(filters)
    const response = await httpService.get(`/reports/attribute-report/${clientId}`, { params })
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_ATTRIBUTE_SESSION, response.data)
    return response.data
  },
  getOverlapChartData: async function ({ commit, dispatch }, { clientId, ids }) {
    dispatch('resetOverlapChartData')
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    const selectedMsv = msv[clientId] || 1
    const overlapChartData = await httpService.get(`/reports/attribute-report/overlap/${clientId}?ids=${ids.join()}&msv=${selectedMsv}`)
    if (!overlapChartData || !overlapChartData.data) {
      return
    }
    const uniqueIds = new Set()
    // process data for overlap chart
    overlapChartData.sets.forEach(overlapItem => {
      overlapItem.sets.length > 1 && overlapItem.sets.forEach(item => {
        uniqueIds.add(item)
      })
    })
    const filteredSets = []
    overlapChartData.sets.forEach(item => {
      if (item.sets.length > 1 || uniqueIds.has(item.sets[0])) {
        filteredSets.push(item)
      }
    })
    const mappedSets = filteredSets.map(item => {
      return {
        ...item,
        size: item.value
      }
    })
    commit(types.ADD_OVERLAP_CHART, { sets: mappedSets })
  },
  getCustomConstructorData: async function ({ commit }, { clientId, filters, disableSaveToState }) {
    const customReport = await fetchCustomReport({ clientId, filters })
    if (!customReport) {
      return
    }
    !disableSaveToState && commit(types.ADD_CUSTOM_DATA, customReport.result)
    return customReport.response.data
  },
  async getCustomReport ({ commit, dispatch }, { clientId, filters }) {
    dispatch('resetCustomReport')
    const customReport = await fetchCustomReport({ clientId, filters })
    if (!customReport) {
      return
    }
    commit(types.ADD_CUSTOM_REPORT, customReport.result)
  },
  deleteCustomItem ({ commit }, { item }) {
    commit(types.DELETE_CUSTOM_ITEM, item)
  },
  resetData ({ commit }) {
    commit(types.ADD_ATTRIBUTE_SESSION, {})
    commit(types.ADD_OVERLAP_CHART, null)
    commit(types.RESET_CUSTOM_DATA)
  },
  resetOverlapChartData ({ commit }) {
    commit(types.ADD_OVERLAP_CHART, null)
  },
  resetCustomReport ({ commit }) {
    commit(types.ADD_CUSTOM_REPORT, null)
  },
  setNewCustomData ({ commit }, customData) {
    commit(types.SET_NEW_CUSTOM_DATA, customData)
  }
}

/**
 * Store manage data for Reports/Attribute Reports {@link AttributeReport}
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
